import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Input, Button} from 'antd';
import BaseContent from 'components/BaseContent';
import BaseModal from 'components/BaseModal';
import style from './index.less';
import {changePassword} from 'actions/user';
import InputValidate from 'components/InputValidate';
const FormItem = Form.Item;
const MSG_VALID = 'At least 8 characters, must contain letters, numbers, etc';
const MSG_SAME = 'The passwords entered twice are different';


class ChangePassword extends React.Component {
    state = {
        loading: false,
        npassword_hasFeedback: false,
        npassword_confirm_hasFeedback: false,
    };
    constructor(props){
        super(props);
        this.ValidateInput = InputValidate(Input,props.form);
    }


    onSubmit = (e)=> {
        e.preventDefault();
        this.props.form.validateFields(async (error, values)=> {
            if (!error) {
                this.setState({loading: true});
                changePassword(values).then(res=>{
                    BaseModal.success({
                        title: 'Success！',
                        onOk: ()=> {
                            this.setState({loading: false});
                            this.props.history.push('/login');
                        }
                    });
                }).catch(()=>{
                    this.setState({loading: false});
                });
            }
        });
    }
    handleConfirmPassword = (rule, value, callback) => {
        const { getFieldValue } = this.props.form;
        if (value && value !== getFieldValue('npassword')) {
            callback(MSG_SAME);
            return;
        }
        if(value && value.length > 0){
            if (value.length < 8 || !/[0-9]+/.test(value) || !/[a-zA-Z]+/.test(value)) {
                callback(MSG_VALID);
                return;
            }

        }
        callback();
    }
    onChange = (field, e)=> {
        this.setState({[`${field}_hasFeedback`]: false});
    }
    onBlur = (field,e)=> {
        const fieldError = this.props.form.getFieldError(field);
        if (!fieldError) {
            this.setState({[`${field}_hasFeedback`]: true});
        }else {
            this.setState({[`${field}_hasFeedback`]: false});
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const FormItemLayout = {
            labelCol: {
                style: {float:'left',width:'165px'}

            },
            wrapperCol: {
                style: {float:'left',width:'380px'}
            }
        };
        const ValidateInput = this.ValidateInput;


        return (
            <BaseContent style={{minHeight: 0}}>
                <Form layout="horizontal" onSubmit={this.onSubmit} style={{position: 'relative', paddingTop: 40}}>
                    <div style={{padding: '0 30px',overflow:'hidden'}}>
                        <FormItem {...FormItemLayout} label="Current password " colon={false}>
                            {getFieldDecorator('opassword', {
                                validateTrigger: 'onBlur',
                                rules: [
                                    {required: true, message: 'please input current password'}
                                ]
                            })(
                                <ValidateInput type="password" placeholder="Please fill in the current password" onChange={this.onChange.bind(this,'opassword')}/>
                            )}
                        </FormItem>

                        <FormItem {...FormItemLayout} label="New password" colon={false} hasFeedback={this.state.npassword_hasFeedback}>
                            {getFieldDecorator('npassword', {
                                validateTrigger: 'onBlur',
                                rules: [
                                    {required: true, message: 'please input new password'},
                                    {validator: (rule, value, callback) => {
                                        if(value && value.length > 0){
                                            if (value.length < 8 || !/[0-9]+/.test(value) || !/[a-zA-Z]+/.test(value)) {
                                                callback(MSG_VALID);
                                                return;
                                            }

                                        }
                                        callback();
                                    }}
                                ]

                            })(
                                <ValidateInput
                                    type="password"
                                    placeholder="Please fill in the new password"
                                    onChange={this.onChange.bind(this,'npassword')}
                                    onBlur={this.onBlur.bind(this,'npassword')}/>
                            )}
                        </FormItem>

                        <FormItem {...FormItemLayout} label="Retype new password" colon={false} hasFeedback={this.state.npassword_confirm_hasFeedback}>
                            {getFieldDecorator('npassword_confirm', {
                                validateTrigger: 'onBlur',
                                rules: [
                                    {required: true, message: 'please retype new password'},
                                    {validator: this.handleConfirmPassword}
                                ]

                            })(
                                <ValidateInput
                                    type="password" placeholder="Please fill in the new password"
                                    onChange={this.onChange.bind(this, 'npassword_confirm')}
                                    onBlur={this.onBlur.bind(this,'npassword_confirm')}/>
                            )}
                        </FormItem>
                    </div>
                    <div className={style.primary}>
                        <Button type="primary" htmlType="submit" loading={this.state.loading}>Confirm</Button>
                    </div>

                </Form>
            </BaseContent>
        );
    }
}
const WrapperChangePassword = Form.create()(ChangePassword);
export default withRouter(WrapperChangePassword);



// WEBPACK FOOTER //
// ./src/pages/ChangePassword/index.js